// extracted by mini-css-extract-plugin
export default {"wrapper":"StaisticsGraph_wrapper__kYDpl"};